<div class="modal-backdrop">
  <div class="modal-content">
    <div class="modal-header">
      <img alt="icono" src="assets/icons/error.svg">
      <h2 class="modal-title">No hay tokens generados para esta campaña</h2>

    </div>
    <div class="modal-body">
      <p>¿Quieres generarlos en este momento?</p>
    </div>
    <div class="modal-footer">
      <button (click)="onCancel()" class="btn btn-secondary">Atrás</button>
      <button (click)="onConfirm()" class="btn btn-primary">Generar tokens</button>
    </div>
  </div>
</div>
